import { ApiError, formatApiError } from './laravelError';

/**
 * Map Laravel validation errors to { fieldName: firstMessage } for form inputs.
 */
export function mapApiErrorToFieldErrors(error) {
  if (!(error instanceof ApiError) || !error.errors) {
    return {};
  }

  const result = {};
  Object.entries(error.errors).forEach(([key, messages]) => {
    if (Array.isArray(messages) && messages.length > 0) {
      result[key] = messages[0];
    } else if (typeof messages === 'string') {
      result[key] = messages;
    }
  });
  return result;
}

/**
 * Resolve a single field error, checking snake_case and camelCase keys.
 */
export function getFieldError(fieldErrors, fieldName) {
  if (!fieldErrors || !fieldName) return '';
  return (
    fieldErrors[fieldName]
    || fieldErrors[fieldName.replace(/([A-Z])/g, '_$1').toLowerCase()]
    || ''
  );
}

export function getFormErrorMessage(error, fallback = 'Request failed') {
  return formatApiError(error, fallback);
}
